const Badge = ({
  variant = 'light',
  color = 'primary',
  size = 'md',
  startIcon,
  endIcon,
  children,
  onClick,
  className = '',
  type = 'button',
  ...rest
}) => {
  const baseStyles =
    'inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium';

  // Define size styles
  const sizeStyles = {
    sm: 'text-theme-xs', // Smaller padding and font size
    md: 'text-sm', // Default padding and font size
  };

  const variants = {
    light: {
      primary:
        'bg-brand-50 text-brand-500 dark:bg-brand-500/15 dark:text-brand-400',
      success:
        'bg-success-50 text-success-600 dark:bg-success-500/15 dark:text-success-500',
      error:
        'bg-error-50 text-error-600 dark:bg-error-500/15 dark:text-error-500',
      warning:
        'bg-warning-50 text-warning-600 dark:bg-warning-500/15 dark:text-orange-400',
      info: 'bg-blue-light-50 text-blue-light-500 dark:bg-blue-light-500/15 dark:text-blue-light-500',
      light: 'bg-gray-100 text-gray-700 dark:bg-white/5 dark:text-white/80',
      dark: 'bg-gray-500 text-white dark:bg-white/5 dark:text-white',
    },
    solid: {
      primary: 'bg-brand-500 text-white dark:text-white',
      success: 'bg-success-500 text-white dark:text-white',
      error: 'bg-error-500 text-white dark:text-white',
      warning: 'bg-warning-500 text-white dark:text-white',
      info: 'bg-blue-light-500 text-white dark:text-white',
      light: 'bg-gray-400 dark:bg-white/5 text-white dark:text-white/80',
      dark: 'bg-gray-700 text-white dark:text-white',
    },
  };

  // Get styles based on size and color variant
  const sizeClass = sizeStyles[size];
  const colorStyles = variants[variant][color];

  const interactiveStyles = onClick
    ? 'cursor-pointer select-none border-0 font-inherit text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-1 dark:focus-visible:ring-offset-gray-900'
    : '';

  // Put colorStyles after interactiveStyles so light/solid backgrounds win over UA button styles
  const combinedClassName =
    `${baseStyles} ${sizeClass} ${interactiveStyles} ${colorStyles} ${className}`.trim();

  if (onClick) {
    return (
      <button
        type={type}
        className={combinedClassName}
        onClick={onClick}
        {...rest}
      >
        {startIcon && <span className="mr-1">{startIcon}</span>}
        {children}
        {endIcon && <span className="ml-1">{endIcon}</span>}
      </button>
    );
  }

  return (
    <span className={combinedClassName} {...rest}>
      {startIcon && <span className="mr-1">{startIcon}</span>}
      {children}
      {endIcon && <span className="ml-1">{endIcon}</span>}
    </span>
  );
};

export default Badge;
